module.exports = __webpack_public_path__ + "img/finance.3c1ce62d.svg";